/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState } from 'react'

import { NORESULT } from '../../utils/constants/rhybus-config'

interface ChecklistListProps {
  selectedChecklist: any[]
}
const CheckListCreateInquiry = ({
  selectedChecklist,
}: ChecklistListProps) => {

  return (
    <div>
      {!selectedChecklist || selectedChecklist.length === 0 ? (
        <div
          aria-label={NORESULT}
          className='subtitle-color2 montserratregular font-12 text-center py-2 min-h-200 d-flex align-items-center justify-content-around'
          tabIndex={0}
        >
          {NORESULT}
        </div>
      ) : (
        <div className='checklistlist'>
          <ul className='m-0 p-2 list-type-none'>
            {selectedChecklist &&
              selectedChecklist.map((item: any, key) => (
                <li
                  aria-label={item?.Description}
                  className='py-1 maxfitcontent latomedium font-12 title-color3 '
                  key={key}
                  tabIndex={0}
                  title={item?.Description}
                >
                  {item?.Description}
                </li>
              ))}
          </ul>
        </div>
      )}
    </div>
  )
}

export default CheckListCreateInquiry
